var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientRegImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 112,
    viewBox: "0 0 82 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 19.6667,
    y: 1,
    width: 43.5,
    height: 54,
    rx: 21.75,
    fill: "white",
    stroke: "#009688",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M18.6667 26.8333H26.8334C30.6994 26.8333 33.8334 23.6993 33.8334 19.8333V17.5",
    stroke: "#009688",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M62.9999 26.8334H40.8332C36.9673 26.8334 33.8333 23.6994 33.8333 19.8334V9.33337",
    stroke: "#009688",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    opacity: 0.2,
    d: "M33.2499 19.2501H32.2499V21.0001C32.2499 22.7651 31.3163 24.0211 29.7887 24.887C28.2247 25.7735 26.098 26.2001 24 26.2001H20.2V24.0001C20.2 12.1812 29.7811 2.6001 41.6 2.6001C53.4188 2.6001 63 12.1812 63 24.0001V26.2001H44.8C39.8132 26.2001 37.227 24.7308 35.8738 23.2303C34.4951 21.7016 34.2499 19.9796 34.2499 19.2501H33.2499Z",
    fill: "#009688",
    stroke: "#009688",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Subtract_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_80_404",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8125 60.6666L40.25 74.6667L54.6875 60.6666H56.5833H65.6667C74.5032 60.6666 81.6667 67.8301 81.6667 76.6666V112H0V76.6666C0 67.8301 7.16345 60.6666 16 60.6666H20.4167H25.8125Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8125 60.6666L40.25 74.6667L54.6875 60.6666H56.5833H65.6667C74.5032 60.6666 81.6667 67.8301 81.6667 76.6666V112H0V76.6666C0 67.8301 7.16345 60.6666 16 60.6666H20.4167H25.8125Z",
    fill: "#009688",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.25 74.6667L38.8577 76.1025L40.25 77.4526L41.6423 76.1025L40.25 74.6667ZM25.8125 60.6666L27.2047 59.2308L26.6229 58.6666H25.8125V60.6666ZM54.6875 60.6666V58.6666H53.8771L53.2952 59.2308L54.6875 60.6666ZM81.6667 112V114H83.6667V112H81.6667ZM0 112H-2V114H0V112ZM41.6423 73.2309L27.2047 59.2308L24.4202 62.1024L38.8577 76.1025L41.6423 73.2309ZM53.2952 59.2308L38.8577 73.2309L41.6423 76.1025L56.0798 62.1024L53.2952 59.2308ZM54.6875 62.6666H56.5833V58.6666H54.6875V62.6666ZM56.5833 62.6666H65.6667V58.6666H56.5833V62.6666ZM65.6667 62.6666C73.3986 62.6666 79.6667 68.9346 79.6667 76.6666H83.6667C83.6667 66.7255 75.6078 58.6666 65.6667 58.6666V62.6666ZM79.6667 76.6666V112H83.6667V76.6666H79.6667ZM81.6667 110H0V114H81.6667V110ZM2 112V76.6666H-2V112H2ZM2 76.6666C2 68.9346 8.26801 62.6666 16 62.6666V58.6666C6.05888 58.6666 -2 66.7255 -2 76.6666H2ZM16 62.6666H20.4167V58.6666H16V62.6666ZM20.4167 62.6666H25.8125V58.6666H20.4167V62.6666Z",
    fill: "#009688",
    mask: "url(#path-5-inside-1_80_404)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M53.6667 84.5834H69.4167",
    stroke: "#009688",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M40.25 75.25V92.85",
    stroke: "#009688",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientRegImg);
export default __webpack_public_path__ + "static/media/patientRegImg.4e64e9ed9121e87d3fb52a2d719d5173.svg";
export { ForwardRef as ReactComponent };